import { call } from 'redux-saga/effects';
import { omitBy } from 'lodash/fp';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import { ItemType } from '../../../../../constants/inventory/InventoryTypes';
import { fetchOnHoldReservations as fetchOnHoldReservationsRoutine } from './routines';

const ON_HOLD_RESERVATION_FIELDS = [
  'id',
  'firstName',
  'lastName',
  'requestTime',
  'status',
  'heldQuantity',
  'email',
  'guest'
];

export const fetchOnHoldReservations = ({ payload = {} }) => {
  const { type, id, locationId, zoneId, ...qs } = payload;
  const query = omitBy(
    value => value === null || value === undefined || value === '',
    {
      ...qs,
      inventoryItemId: id,
      inventoryLocationId: locationId,
      inventoryLocationZoneId: type === ItemType ? zoneId : undefined,
      fields: ON_HOLD_RESERVATION_FIELDS
    }
  );

  return sagaRoutineRequest(fetchOnHoldReservationsRoutine, {
    request: () => call(Api.fetchReservationsWithOnholdItems, { qs: query })
  });
};
